// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"513":"4018078e","538":"94a4a0c9","703":"dae516a5","983":"def664c4"}[chunkId] + ".chunk.js";
};